import api from './api'

export const userBasePath = '/api/v1/user'

export async function getMe() {
  const resp = await api.get(`${userBasePath}/me`)
  return resp.data
}

export async function updateUser(userUpdate) {
  const resp = await api.patch(`${userBasePath}`, userUpdate)
  return resp.data
}

export async function login(loginData) {
  const resp = await api.post(`${userBasePath}/login`, loginData)
  return resp.data
}

export async function kauLogin(loginData) {
  const resp = await api.post(`${userBasePath}/kau-login`, loginData)
  return resp.data
}

export async function kauLogout(relayState) {
  const resp = await api.post(`${userBasePath}/kau-logout`, { relayState })
  return resp.data
}
export async function logout() {
  const resp = await api.post(`${userBasePath}/logout`)
  return resp.data
}

export async function register(registrationData) {
  const resp = await api.post(`${userBasePath}`, registrationData)
  return resp.data
}

export async function validateResetToken(passwordResetToken) {
  const resp = await api.post(`${userBasePath}/forgot-password/verify`, {
    passwordResetToken
  })
  return resp.data
}

export async function resetPassword({ password, passwordResetToken, userId }) {
  const resp = await api.patch(`${userBasePath}/${userId}/password`, { password, passwordResetToken })
  return resp.data
}

export async function modifyPassword({ password, newPassword, email }) {
  const resp = await api.patch(`${userBasePath}/modifyPassword`, { password, newPassword, email })
  return resp.data
}

export async function initiatePasswordReset(email) {
  const resp = await api.post(`${userBasePath}/forgot-password`, { email })
  return resp.data
}

export async function validateConfirmationData(confirmationData) {
  const resp = await api.post(`${userBasePath}/confirm/verify`, confirmationData)
  return resp.data
}

export async function confirmRegistration({ userId, ...confirmationData }) {
  const resp = await api.post(`${userBasePath}/${userId}/confirm`, confirmationData)
  return resp.data
}

export async function listUsers() {
  const resp = await api.get(`${userBasePath}/list`)
  return resp.data
}

export async function patchUser(id, roleId) {
  const resp = await api.patch(`${userBasePath}/update-user`, { id, roleId })
  return resp.data
}

export async function getRoles() {
  const resp = await api.get(`${userBasePath}/roles`)
  return resp.data
}

export async function getAuthStrategy() {
  const resp = await api.get(`${userBasePath}/auth/get-strategy`)
  return resp.data
}
